import { BasicMetaData } from "./basic-metadata";
import { ContentMetaData } from "./content-metadata";
import { ExtraMetaData } from "./extra-metadata";
import { RightsMetaData } from "./rights-metadata";
import { SourceMetaData } from "./source-metadata";
import { WorkflowMetaData } from "./workflow-metadata";

export class MetaData {
    public __classname__: string = 'MetaData';


    public BasicMetaData: BasicMetaData | null = null;

    public RightsMetaData: RightsMetaData | null = null;

    public SourceMetaData: SourceMetaData | null = null;

    public ContentMetaData: ContentMetaData | null = null;

    public WorkflowMetaData: WorkflowMetaData | null = null;

    public ExtraMetaData: ExtraMetaData | null = null;

    constructor(
        params : MetaDataNamedParameters
    ) {
        this.BasicMetaData = params.BasicMetaData ?? null;
        this.RightsMetaData = params.RightsMetaData ?? null;
        this.SourceMetaData = params.SourceMetaData ?? null;
        this.ContentMetaData = params.ContentMetaData ?? null;
        this.WorkflowMetaData = params.WorkflowMetaData ?? null;
        this.ExtraMetaData = params.ExtraMetaData ?? null;
    }

}

export interface MetaDataNamedParameters {
    BasicMetaData?: BasicMetaData,
    RightsMetaData?: RightsMetaData,
    SourceMetaData?: SourceMetaData,
    ContentMetaData?: ContentMetaData,
    WorkflowMetaData?: WorkflowMetaData,
    ExtraMetaData?: ExtraMetaData
}